module.exports = __webpack_public_path__ + "static/media/weather-image.6f01ea24.png";